<div class="login-page d-flex flex-column flex-root" id="kt_app_root">
  <div class="d-flex flex-column flex-lg-row flex-column-fluid min-vh-100">
    <!-- Form Side -->
    <div
      class="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1"
    >
      <div class="d-flex flex-center flex-column flex-lg-row-fluid">
        <div class="w-lg-500px p-10">
          <div class="text-center mb-11">
            <h1 class="text-gray-900 fw-bolder mb-3" style="font-size: 2.25rem">
              {{ "resetPassword.title" | translate }}
            </h1>

            <div class="text-gray-500 fw-semibold" style="font-size: 1.25rem">
              {{ "resetPassword.subTitle" | translate }}
            </div>
          </div>
          <!-- Reset Password -->
          <form
            [formGroup]="resetPasswordForm"
            (submit)="submitNewPassword($event)"
            class="form w-100"
            novalidate="novalidate"
            id="kt_sign_in_form"
            data-kt-redirect-url="#"
            action="#"
          >
            <div class="col-md-12 mt-4">
              <div class="form-floating">
                <input
                  formControlName="password"
                  class="form-control"
                  id="inputNewPassword"
                  type="password"
                  placeholder="Secret password"
                />
                <label for="inputNewPassword">{{
                  "newPassword" | translate
                }}</label>
                <div
                  *ngIf="isResetPasswordControlInvalid('password')"
                  class="text-danger"
                >
                  <div
                    *ngIf="resetPasswordForm.get('password')?.errors?.['required'] ||
                  resetPasswordForm.get('password')?.errors?.['minlength'] ||
                  resetPasswordForm.get('password')?.errors?.['pattern'] "
                  >
                    {{ "alerts.resetPasswordError" | translate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 mt-4">
              <div class="form-floating">
                <input
                  formControlName="confirmPassword"
                  class="form-control"
                  id="inputNewConfirmPassword"
                  type="password"
                  placeholder="Confirm Password"
                />
                <label for="inputNewConfirmPassword">{{
                  "confirmPassword" | translate
                }}</label>
                <div class="text-danger">
                  <div
                    *ngIf="resetPasswordForm.get('confirmPassword')?.errors?.['required'] ||
                  resetPasswordForm.get('confirmPassword')?.errors?.['minlength'] ||
                  resetPasswordForm.get('confirmPassword')?.errors?.['pattern'] "
                  >
                    {{ "alerts.resetPasswordError" | translate }}
                  </div>
                  <div
                    *ngIf="resetPasswordForm.get('confirmPassword')?.errors?.['passwordMismatch']"
                  >
                    {{ "passwordsDoNotMatch" | translate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="d-grid mb-10 mt-8">
              <button type="submit" class="btn btn-primary cursor-pointer">
                <span class="indicator-label">
                  {{ "resetPassword.setNewPassword" | translate }}
                </span>
              </button>
            </div>
          </form>

          <!-- Back to login -->
          <div class="d-grid mb-10">
            <p class="text-center mt-2">
              <a class="text-primary" routerLink="/login"
                ><i class="feather icon-chevron-left"></i
                >{{ "backToLogin" | translate }}</a
              >
            </p>
          </div>
          <div
            class="w-lg-500px d-flex flex-stack px-10 mx-auto"
            style="justify-content: end"
          ></div>
        </div>
      </div>
    </div>

    <!-- Image Side -->
    <div
      class="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2"
      style="background-image: url(assets/media/misc/auth-bg.png)"
    >
      <div
        class="d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100"
      >
        <div class="w-lg-500px d-flex justify-content-center mb-5">
          <img src="assets/media/Dermalogic_white.png" class="w-100" alt="Logo" />
        </div>

        <img
          class="d-none d-lg-block mx-auto w-275px w-md-50 w-xl-600px mt-lg-1 mb-10 mb-lg-10"
          src="assets/media/login-final.png"
          alt=""
        />
        <h1
          class="d-none d-lg-block text-white fs-2qx fw-bolder text-center mb-7"
        >
          Dermalogic.Health
        </h1>
        <div class="d-none d-lg-block text-white fs-base text-center">
          {{ "descriptionText" | translate }}<br />
          v1.13.0 {{ currentYear }}
        </div>
      </div>
    </div>
  </div>
</div>
